<script>
export default {
    name: 'IlluBulb',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7'
        },

        secondaryColor: {
            type: String,
            default: '#313132'
        },
    }
}
</script>
<template>
    <svg
        class="base-illu illu-bulb"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <rect
                :stroke="secondaryColor" class="secondary-color"
                x="24.5"
                y="48.5"
                width="15"
                height="3"
                rx="1.5"
            />
            <path
                d="M37.473 51.5H26.527a4.486 4.486 0 001.291 2.682A4.486 4.486 0 0031 55.5h2a4.486 4.486 0 003.182-1.318 4.486 4.486 0 001.29-2.682z"
                :stroke="secondaryColor" class="secondary-color"
            />
            <rect
                :stroke="secondaryColor" class="secondary-color"
                x="24.5"
                y="45.5"
                width="15"
                height="3"
                rx="1.5"
            />
            <path
                d="M32 8.5c-3.936 0-7.5 1.81-10.11 4.593C19.183 15.98 17.5 19.918 17.5 24c0 5.07 2.88 10.13 5.437 14.672 1.38 2.45 2.674 4.753 3.419 6.828h11.288c.745-2.075 2.039-4.378 3.419-6.828C43.62 34.13 46.5 29.07 46.5 24c0-4.082-1.683-8.02-4.39-10.907C39.5 10.31 35.936 8.5 32 8.5z"
                :stroke="secondaryColor" class="secondary-color"
            />
            <path
                d="M36 26a3 3 0 010 6h-1v13h-2V32h-2v8h-2v-8h-1a3 3 0 112.995-3.176L31 29v1h2v-1a3 3 0 013-3zm-8 2a1 1 0 100 2 1 1 0 000-2zM16.95 39.293a1 1 0 010 1.414l-4.243 4.243a1 1 0 01-1.414-1.414l4.243-4.243a1 1 0 011.414 0zm31.757 0l4.243 4.243a1 1 0 01-1.414 1.414l-4.243-4.243a1 1 0 011.414-1.414zM55 28a1 1 0 010 2h-6a1 1 0 010-2h6zm-40 0a1 1 0 010 2H9a1 1 0 010-2h6zm21 0a1 1 0 110 2 1 1 0 010-2zM11.586 10.172l4.242 4.242a1 1 0 11-1.414 1.414l-4.242-4.242a1 1 0 111.414-1.414zm42.242 0a1 1 0 010 1.414l-4.242 4.242a1 1 0 11-1.414-1.414l4.242-4.242a1 1 0 011.414 0z"
                :fill="primaryColor" class="primary-color"
            />
        </g>
    </svg>
</template>
